import { InjectionToken } from "@angular/core";

export const API_SERVER_URL_TOKEN = new InjectionToken<string>('API_SERVER_URL_TOKEN');
